import { ReactNode } from "react";
import { cn } from "@/lib/utils";
import { SectionBgWithIcon } from "@/components/common/section-bg-with-icon";

export const SectionTitleWithIcon = ({
  children,
  className,
  sectionKey,
}: {
  children: ReactNode;
  className?: string;
  sectionKey: SectionKey;
}) => {
  return (
    <header className={cn("flex gap-3 md:gap-4", className)}>
      <div className={"relative -top-0.5 md:-top-0.25"}>
        <SectionBgWithIcon sectionKey={sectionKey} type={"title"} />
      </div>
      {children}
    </header>
  );
};
